// extracted by mini-css-extract-plugin
module.exports = {"small":"480px","mobile":"850px","tablet":"1030px","desktop":"1300px"};